import styled from 'styled-components';

// Components
import { Modal, Icon, Space } from '@cashfree-intl/coherent';
import ActionModal from 'components/ActionModal';

// Images
import cancelledCheque from 'images/cancelled-cheque.svg';

export const StyledCancelledChequeModal = styled(Modal)`
  .content {
    padding: 2.5rem 3rem !important;
    display: flex !important;
    align-items: center;
    flex-direction: column;
  }
  .footer {
    width: 100%;
  }
  .title {
    font-size: 18px;
    margin-bottom: 1.5rem;
    text-align: center;
  }
  .subtitle {
    font-family: 'dm-sans';
    font-weight: 400;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
  }
  .close-icon {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }
  .error-icon {
    svg {
      width: 3rem;
      height: 3rem;
    }
  }
  .cancelled-cheque-img {
    height: 8.813rem;
    width: 19.25rem;
    background-position: top center;
    background-image: url(${cancelledCheque});
    box-shadow: 0px 10px 10px 0px rgba(0, 40, 107, 0.1);
  }
`;

export const StyledEditChequeModal = styled(Modal)`
  .content {
    padding: 2.5rem 2rem !important;
  }
  .edit-icon {
    margin-right: 0.25rem;
  }
`;

export const StyledReviewModal = styled(Modal)`
  .title {
    font-size: 24px;
    margin-bottom: 1rem;
    margin-top: 0.375rem;
  }
  .chip {
    display: flex;
    padding: 0.125rem 0.75rem;
    align-items: center;
    background-color: #ede4ff;
    border-radius: 20px;
    margin-bottom: 1.5rem;
  }
  .mt-4px {
    margin-top: 0.25rem;
  }
`;

export const StyledChangeAccountModal = styled(ActionModal)`
  .field > .input {
    margin-bottom: 0.25rem;
  }
`;

export const StyledAccountHeaderIcon = styled(Icon)`
  position: absolute;
  right: 1rem;
  margin-left: 1rem;
  cursor: pointer;
`;

export const StyledPayoutListSection = styled(Space)`
  max-height: 20rem;
  overflow-y: auto;
`;
